import React, { Component } from "react";
import { Row, Col, Button, Form, Select, message, Input, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import "./FolderCase.css";
import { withRouter } from "react-router-dom";
import { API } from "../../../API/API";
import UserContext from "../../UserContext/UserContext";
class FolderCaseAdd extends Component {
  static contextType = UserContext;
  formRef = React.createRef();
  state = {
    id: 0,
    invitationid: this.props.invitationid,
    documentname: "",
    filename: "",
    filedata: null,
    filelist: [],
    dkey: 1,
  };
  componentDidMount = () => {
    this.getData();
  };
  getData = () => {
    API.get("/getFolderCaseById?id=" + this.state.id).then((response) => {
      if (response.status === 200) {
        if (response.data.retData.length > 0) {
          this.setState({
            documentname: response.data.retData[0].documentname,
            filename: response.data.retData[0].filename,
          });
        }
      }
    });
  };
  fileOnChange = (info) => {
    this.setState({
      filelist: info.fileList,
      filedata: info.file,
      filename: info.file.name,
    });
  };
  onChangeName = (e) => {
    this.setState({ documentname: e.target.value });
  };

  onSave = () => {
    if (this.state.documentname && this.state.filedata) {
      let body = {
        id: 0,
        invitationid: this.state.invitationid,
        documentname: this.state.documentname,
        createdby: this.context.username,
      };
      API.post("/saveFolderCase", body).then((response) => {
        if (response.status === 200 && response.data.retType === 0) {
          let docid = response.data.retData;
          const formData = new FormData();
          formData.append(
            this.state.filename,
            this.state.filedata.originFileObj
          );
          API.post(
            "/saveTenderDocFile?sourcetype=FolderCase&docid=" + docid,
            formData
          ).then((response) => {
            if (response.status === 200) {
              message.success("Амжилттай хадгаллаа.");
              this.props.showForm(false, 0);
            }
          });
        }
      });
    }
  };
  render() {
    return (
      <div id="document-add" key={this.state.dkey}>
        <Form
          className="formDrawer"
          ref={this.formRef}
          onFinish={this.onSubmit}
          layout="vertical"
          initialValues={{}}
        >
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Form.Item
                style={{ fontWeight: 700 }}
                label="Хавтаст хэргийн нэр"
                name="documentname"
                initialValue={this.state.documentname}
                rules={[
                  {
                    required: true,
                    message: "Хавтаст хэргийн нэр оруулна уу.",
                  },
                ]}
              >
                <Input
                  size="middle"
                  onChange={this.onChangeName}
                  defaultValue={this.state.documentname}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Form.Item
                style={{ fontWeight: 700 }}
                label="Файл оруулах"
                name="filename"
                rules={[
                  {
                    required: true,
                    message: "Файл оруулна уу.",
                  },
                ]}
              >
                <Upload
                  accept="*"
                  openFileDialogOnClick
                  onChange={this.fileOnChange}
                  showUploadList={false}
                  fileList={this.state.filelist}
                >
                  <Button style={{ width: "100%" }}>
                    <Row align="middle" justify="space-between">
                      <Col>{this.state.filename}</Col>
                      <Col>
                        <UploadOutlined />
                      </Col>
                    </Row>
                  </Button>
                </Upload>
              </Form.Item>
            </Col>
          </Row>
          <Form.Item className="buttonForm" label=" ">
            <Button
              type="primary"
              style={{
                width: "100%",
                backgroundColor: "#0358A7",
                borderRadius: 2,
                height: 40,
              }}
              htmlType="submit"
              onClick={this.onSave}
            >
              Хадгалах
            </Button>
          </Form.Item>
        </Form>
      </div>
    );
  }
}

export default withRouter(FolderCaseAdd);
